import { useTranslation } from 'react-i18next';
import site from '@/config/site.json';
import { Target, MapPin, ShieldCheck, Mail, Send } from 'lucide-react';
import { Card } from '@/components/ui/Card';
import { useSeo } from '@/hooks/useSeo';

const VALUES = [
  { key: 'practical', Icon: Target },
  { key: 'local', Icon: MapPin },
  { key: 'quality', Icon: ShieldCheck },
] as const;

export function About() {
  const { t } = useTranslation();

  useSeo({
    title: 'Biz haqimizda — SQLMaster.uz',
    description:
      "SQLMaster.uz — O'zbekistonda SQL o'rganish va amaliyot platformasi. Maqsadimiz, jamoamiz va qadriyatlarimiz haqida.",
    path: '/about',
  });

  return (
    <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
      {/* Hero */}
      <div className="mb-16 text-center">
        <h1 className="text-3xl font-bold sm:text-4xl">{t('about.title')}</h1>
        <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-content-secondary">
          {t('about.subtitle')}
        </p>
      </div>

      {/* Mission + Story */}
      <div className="mb-16 grid gap-6 md:grid-cols-2">
        <Card className="p-6">
          <h2 className="mb-3 text-xl font-semibold">{t('about.missionTitle')}</h2>
          <p className="leading-relaxed text-content-secondary">{t('about.missionText')}</p>
        </Card>
        <Card className="p-6">
          <h2 className="mb-3 text-xl font-semibold">{t('about.storyTitle')}</h2>
          <p className="leading-relaxed text-content-secondary">{t('about.storyText')}</p>
        </Card>
      </div>

      {/* Values */}
      <div className="mb-16">
        <h2 className="mb-8 text-center text-2xl font-bold">{t('about.valuesTitle')}</h2>
        <div className="grid gap-6 md:grid-cols-3">
          {VALUES.map(({ key, Icon }) => (
            <div key={key} className="text-center">
              <div className="feature-icon mx-auto mb-4">
                <Icon className="h-6 w-6" />
              </div>
              <h3 className="mb-2 font-semibold">{t(`about.values.${key}.title`)}</h3>
              <p className="text-sm leading-relaxed text-content-secondary">{t(`about.values.${key}.desc`)}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Contact */}
      <div className="text-center">
        <h2 className="mb-2 text-2xl font-bold">{t('about.contactTitle')}</h2>
        <p className="mx-auto mb-6 max-w-lg text-content-secondary">{t('about.contactText')}</p>
        <div className="flex flex-col justify-center gap-3 sm:flex-row">
          <a href="mailto:hello@sqlmaster.uz" className="btn btn-primary gap-2 px-6 py-3">
            <Mail className="h-5 w-5" />
            hello@sqlmaster.uz
          </a>
          <a href={site.social.telegram} target="_blank" rel="noreferrer" className="btn btn-secondary gap-2 px-6 py-3">
            <Send className="h-5 w-5" />
            Telegram
          </a>
        </div>
      </div>
    </div>
  );
}
